/**
 *=================================== AUTHOR : MUSKAN KHAN===========================
 * ===================================DATE : 10 OCT 2024========================
 */
import InfoPill from "../InfoPill";
import SparkApi from "../../api/SparkApi";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { ShimmerTable } from "react-shimmer-effects";
import { faCancel, faEdit, faSave, faTrash} from "@fortawesome/free-solid-svg-icons";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader} from "react-bs-datatable";
import { useState, useEffect } from "react";
import { useParams , useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import "../../App.css";
import { usePermission } from "../context/PermissionContext";
import Confirm from "../Confirm";

const ProductInventorylineitem = ({ onInventoryUpdate , productBarcode }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [productInventory, setProductInventory] = useState([]);
  const [body, setBody] = useState();
  const labels = { beforeSelect: " " };
  const { permissionData , userInfo } = usePermission();
  const can_read = permissionData?.Product_Inventory?.can_read;
  const can_create = permissionData?.Product_Inventory?.can_create;
  const can_edit = permissionData?.Product_Inventory?.can_edit;
  const can_delete = permissionData?.Product_Inventory?.can_delete;
  const [modalShow, setModalShow] = useState(false);
const [rowToDelete, setRowToDelete] = useState(null);

  useEffect(() => {
    fetchProductInventories();
  }, []);

  const [editingRows, setEditingRows] = useState({});

  const handleEdit = (row) => {

    setEditingRows((prev) => ({
      ...prev,
      [row.line_item_id]: {
        product_inventory_id: row.product_inventory_id,
        quantity: row.quantity,
        formatted_date: formatDateForInput(row.formatted_date),
        type: row.type,
        supplier: row.supplier,
      },
    }));
  };

  const handleCancel = async (row) => {
    setEditingRows((prev) => {
      const updated = { ...prev };
      delete updated[row.line_item_id];
      return updated;
    });
    if (onInventoryUpdate) {
      onInventoryUpdate();
    }
  };

  const handleSave = async (row) => {
    try {
      const updatedValues = editingRows[row.line_item_id];
      
      if ( parseInt(updatedValues.quantity) <= 0) {
        return toast.error("quantity must be greaterthan '0' .");
      }
      if (!updatedValues) {
        return toast.error("No changes detected for this inventory item.");
        
      }

      const updatedData = await SparkApi.updateinventorylineitem(
        row.line_item_id,
        updatedValues
      );
      const convertDateToDDMMYYYY = (isoDateString) => {
        const date = new Date(isoDateString);

        const day = String(date.getDate()).padStart(2, "0"); // Ensure 2-digit day
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
      };

      if (updatedData.success) {
        const updatedRecord = updatedData.records.record;

        updatedRecord.formatted_date = convertDateToDDMMYYYY(
          updatedRecord.date
        );

        setProductInventory((prev) => {
          const updatedInventory = prev.map((item) =>
            item.line_item_id === row.line_item_id
              ? { ...item, ...updatedRecord }
              : item
          );

          // Sort the updated array based on date and type
          return updatedInventory.sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);

            if (a.rack_name < b.rack_name) return -1;
            if (a.rack_name > b.rack_name) return 1;
            // If dates are equal, compare by type (optional: adjust type comparison logic as needed)
            if (a.type < b.type) return -1;
            if (a.type > b.type) return 1;
            // Compare dates first
            if (dateA < dateB) return -1;
            if (dateA > dateB) return 1;

            return 0; // If both date and type are equal
          });
        });

        setEditingRows((prev) => {
          const updated = { ...prev };
          delete updated[row.line_item_id];
          return updated;
        });
        if (onInventoryUpdate) {
          onInventoryUpdate();
        }
        toast.success("Inventory Line Items updated successfully");
      } else {
        toast.error(updatedData.error);
      }
    } catch (error) {
      toast.error("An error occurred while updating the inventory Line Items");
    }
  };

  const formatDateForInput = (date) => {
    try {
      const parts = date.split("-");
      if (parts.length === 3) {
        return parts[0].length === 4 ? date : `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      throw new Error("Invalid date format");
    } catch (error) {
      return "";
    }
  };

  const handleDelete = async (row) => {
    try {
      // setModalShow(true);
      const response = await SparkApi.deleteinventorylineitems(row.line_item_id);

      if (response.success) {
        setProductInventory((prev) =>
          prev.filter((item) => item.line_item_id !== row.line_item_id)
        );
        if (onInventoryUpdate) {
          onInventoryUpdate();
        }
        toast.success("Inventory Line Item deleted successfully");
      } else {
        toast.error(response.error);
      }
    } catch (error) {
      toast.error("An error occurred while deleting the inventory Line Item");
    }
  };

  const handleFieldChange = (e, row, field) => {
    const value = field === "formatted_date" ? e.target.value : e.target.value;
    setEditingRows((prev) => ({
      ...prev,
      [row.line_item_id]: {
        ...prev[row.line_item_id],
        [field]: value,
      },
    }));
  };

  const header = [
    { title: "Product ", prop: "product_name", isFilterable: true, isSortable:true, },
    { title: "Factory ", prop: "factory_name", isFilterable: true, isSortable:true, },
    { title: "Warehouse ", prop: "warehouse_name", isFilterable: true, isSortable:true, },
    { title: "Rack Name", prop: "rack_name", isFilterable: true, isSortable:true, },
    {
      title: "Quantity",
      prop: "quantity",
      isSortable:true,
      cell: (row) =>
        editingRows[row.line_item_id] ? (
          <Form.Control
            type="numeric"
            value={editingRows[row.line_item_id].quantity}
            onChange={(e) => {
              if (!e.target.value === "" || !isNaN(e.target.value)) {
                handleFieldChange(e, row, "quantity");
              }
            }}
            required
            min={1}
          />
        ) : (
          row.quantity
        ),
      isFilterable: true,
    },
    {
      title: "Date",
      prop: "formatted_date",
      isSortable:true,
      cell: (row) =>
        editingRows[row.line_item_id] ? (
          <Form.Control
            type="date"
            value={
              editingRows[row.line_item_id].formatted_date ||
              formatDateForInput(row.formatted_date)
            }
            onChange={(e) => handleFieldChange(e, row, "formatted_date")}
          />
        ) : (
          row.formatted_date
        ),
      isFilterable: true,
    },
    {
      title: "Type",
      prop: "type",
      isSortable:true,
      cell: (row) =>
        row.type === "check-in" ? (
          <Button
            className="btn-sm check-in-out-badge-productinventory-line-item"
            variant="success"
          >
            Check-In
          </Button>
        ) : (
          <Button
            className="btn-sm check-in-out-badge-productinventory-line-item"
            variant="danger"
          >
            Check-Out
          </Button>
        ),
      isFilterable: true,
    },
    {
      title: "Supplier",
      isSortable:true,
      prop: "supplier",
      cell: (row) =>
        editingRows[row.line_item_id] ? (
          <Form.Control
            type="text"
            value={editingRows[row.line_item_id].supplier}
            onChange={(e) => handleFieldChange(e, row, "supplier")}
          />
        ) : row.supplier === "Unknown" ? (
          ""
        ) : (
          row.supplier
        ),
      isFilterable: true,
    },
    userInfo?.userrole === "ADMIN" || can_edit || can_delete ?
    {
      title: "Actions",
      prop: "",
      cell: (row) => (
        <>
          {editingRows[row.line_item_id] ? (
            <>
              <Button
                className="btn-sm"
                variant="success"
                onClick={() => handleSave(row)}
              >
                <FontAwesomeIcon icon={faSave} />
              </Button>
              <Button
                className="btn-sm"
                variant="danger"
                onClick={() => handleCancel(row)}
                style={{ marginLeft: "10px" }}
              >
                <FontAwesomeIcon icon={faCancel} />
              </Button>
            </>
          ) : (
            <>
              {(userInfo?.userrole === "ADMIN" || can_edit) &&
                (<Button
                  className="btn-sm"
                  variant="primary"
                  onClick={() => handleEdit(row)}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </Button>
              )}
              {(userInfo?.userrole === "ADMIN" || can_delete) &&
                (<Button
                  className="btn-sm"
                  variant="danger"
                  onClick={() => {
                    setModalShow(true);   // Show confirmation modal
                    setRowToDelete(row);  // Store row data for deletion
                  }}                
                  style={{ marginLeft: "10px" }}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              )}
            </>
          )}
        </>
      ),
    } : null,
  ].filter(Boolean);

  const fetchProductInventories = async () => {
    try {
      if(can_read){
      const result = await SparkApi.fetchAllProductsinventory(id);

      if (result.success) {
        setProductInventory(result.records);
        setBody(result.records);
      } else {
        setProductInventory([]);
      }
    }
    } catch (error) {
      setProductInventory([]);
    }
  };
  
  return (
    <Row className="g-0">
      {modalShow && (
             <Confirm
             show={modalShow}
             onHide={() => setModalShow(false)} // Hide modal on cancel
             deleteProductLineItem={() => {
               if (rowToDelete) {
                 handleDelete(rowToDelete);  // Delete the stored row
               }
               setModalShow(false); // Close modal after delete
             }}
             title="Confirm delete?"
             message="You are going to delete the record. Are you sure?"
             table="productInventoryLineItem"
           />
          )}
      <Col lg={12}>
        {productInventory ? (
          <DatatableWrapper
            body={productInventory}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 10,
                options: [5, 10, 15, 20],
              },
            }}
          >
            <Row className="mb-4">
              <Col xs={12} lg={4} className="d-flex flex-col justify-content-end align-items-end">
                <Filter />
              </Col>
              <Col xs={12} md={8} sm={6} lg={5} className="d-flex flex-col align-items-start productLineItemsPageSize">
                <PaginationOptions labels={labels} />
                <div className="mt-2">
                  <InfoPill left="Total Product Line Item" right={body ? body.length : 0}/>
                </div>
              </Col>
              {(userInfo?.userrole === "ADMIN" || can_create && can_read) && 
                (<Col xs={12} md={4} sm={6} lg={3} className="d-flex flex-col align-items-end productLineItemsBtn">
                  <Button className="btn-sm mx-2" variant="outline-primary" onClick={() => navigate("/checkin" , { state: { productBarcode :productBarcode } })}>
                    Check In
                  </Button>
                  <Button className="btn-sm" variant="outline-primary" onClick={() => navigate("/checkout" , { state: { productBarcode :productBarcode } })}>
                    Check Out
                  </Button>
                </Col>
              )}
            </Row>
            <Table responsive className="pro-line-items data-table">
              <TableHeader />
              <TableBody />
            </Table>
            <Pagination />
          </DatatableWrapper>
        ) : (
          <ShimmerTable row={10} col={8} />
        )}
      </Col>
    </Row>
  );
};

export default ProductInventorylineitem;
